export const routing = {
  locales: ['en', 'tr'],
  defaultLocale: 'en'
};
